import React from "react";
import Tab from "olive-react-myoneui/lib/Tab";
import Nav from "olive-react-myoneui/lib/Nav";
import CourseCurriculum from "./CourseCurriculum";
import CourseOverview from "./CourseOverview";

function CourseCurriculumTabs({coursedetails}) {

  console.log(coursedetails?.course.cb_evidence,"evidence")
  return (
    <div className="course-curriculum-overview">
      <Tab.Container id="course-tabs" defaultActiveKey={`${coursedetails?.course.cb_active_tab == 0 ? "curriculum" : "overview"}`}>
        <Nav variant="pills" className="pt-2 pb-4">
        {coursedetails?.course.cb_evidence == 0 && 
          <Nav.Item>
            {/* <Nav.Link eventKey="curriculum">Curriculum</Nav.Link> */}
            <Nav.Link eventKey={`${coursedetails?.course.cb_active_tab == 0 ? "curriculum" : "overview"}`}>{`${coursedetails?.course.cb_active_tab == 0 ? "Curriculum" : "Overview"}`}</Nav.Link>
          </Nav.Item>
        }
          <Nav.Item>
          <Nav.Link eventKey={`${coursedetails?.course.cb_active_tab == 1 ? "curriculum" : "overview"}`}>{`${coursedetails?.course.cb_active_tab == 1 ? "Curriculum" : "Overview"}`}</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          {coursedetails?.course.cb_evidence == 0 && 
          <CourseCurriculum coursedetails={coursedetails}/>
          }
          <CourseOverview coursedetails={coursedetails}/>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}

export default CourseCurriculumTabs;
